import React, { createContext, useContext, useState } from "react";

export const SidebarARRContext = createContext(null);

export const SidebarARRProvider = ({ children }) => {
  const [collapse, setCollapse] = useState(false);
  return (
    <SidebarARRContext.Provider value={{ collapse, setCollapse }}>
      {children}
    </SidebarARRContext.Provider>
  );
};

export const useARRSidebar = () => useContext(SidebarARRContext);
